/* EPICLABS® · Reveal observer · cargado una sola vez globalmente */
(function(){
  if (window.__epicAnim) return;
  window.__epicAnim = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target, d = parseInt(el.getAttribute('data-epic-delay') || '0', 10);
      setTimeout(function(){
        el.classList.add('epic-visible');
        if (el.hasAttribute('data-epic-stagger')) {
          var kids = el.children;
          for (var i = 0; i < kids.length; i++) {
            kids[i].style.transitionDelay = (i * 45) + 'ms';
          }
        }
      }, d);
      if (el.hasAttribute('data-epic-counter')) ctr(el);
      io.unobserve(el);
    });
  }, { threshold: 0.01, rootMargin: '200px 0px 200px 0px' });

  function ctr(el){
    var raw = el.getAttribute('data-epic-counter'),
        m = raw.replace(/,/g,'').match(/^([^0-9]*)([0-9.]+)(.*)$/);
    if (!m) return;
    var pre=m[1], num=parseFloat(m[2]), suf=m[3],
        dec=m[2].indexOf('.')!==-1?(m[2].split('.')[1]||'').length:0,
        comma=raw.indexOf(',')!==-1, dur=1800, st=null;
    function fmt(n){var f=n.toFixed(dec);if(comma){var p=f.split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');return p.join('.');}return f;}
    function step(ts){if(!st)st=ts;var p=Math.min((ts-st)/dur,1),e=1-Math.pow(1-p,3);el.textContent=pre+fmt(e*num)+suf;if(p<1)requestAnimationFrame(step);else el.textContent=raw;}
    if (reduced) { el.textContent = raw; return; }
    el.textContent = pre + fmt(0) + suf;
    setTimeout(function(){ requestAnimationFrame(step); }, 200);
  }

  var parallax = [];
  function collectParallax(){
    parallax = Array.prototype.slice.call(document.querySelectorAll('[data-epic-parallax]'));
  }
  var ticking = false;
  function onScroll(){
    if (ticking || reduced || !parallax.length) return;
    ticking = true;
    requestAnimationFrame(function(){
      var vh = window.innerHeight;
      parallax.forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-epic-parallax')) || 0.12;
        var shift = ((r.top + r.height/2) - vh/2) * -speed;
        el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
      });
      ticking = false;
    });
  }

  function inView(el){
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh && r.bottom > 0;
  }
  function init(){
    var first = !window.__epicFirstInit;
    /* PASO 1: revelar TODOS los elementos ya en pantalla ANTES de activar
       el gating de opacity:0. Así se elimina el FOUC completamente. */
    document.querySelectorAll('[data-epic-animate], [data-epic-stagger]').forEach(function(el){
      if (first && inView(el)) {
        el.classList.add('epic-instant', 'epic-visible');
        if (el.hasAttribute('data-epic-counter')) ctr(el);
      }
    });
    /* PASO 2: activar el CSS de ocultar elementos fuera de pantalla.
       Los elementos en pantalla ya tienen epic-visible → no se afectan. */
    document.documentElement.classList.add('epic-anim-ready');
    /* PASO 3: observar los elementos fuera de pantalla para su reveal al hacer scroll. */
    document.querySelectorAll('[data-epic-animate], [data-epic-stagger]').forEach(function(el){
      if (el.__epicObs) return;
      el.__epicObs = true;
      if (!el.classList.contains('epic-visible')) {
        io.observe(el);
      }
    });
    window.__epicFirstInit = true;
    collectParallax();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('scroll', onScroll, { passive: true });

  document.addEventListener('shopify:section:load', function(){ setTimeout(init, 100); });

  /* Red de seguridad: revela todo a los 1.2 s */
  setTimeout(function(){
    document.querySelectorAll('[data-epic-animate]:not(.epic-visible)').forEach(function(el){
      el.classList.add('epic-visible');
    });
  }, 1200);
})();
